import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { RgbaStringColorPicker } from "react-colorful";
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import Divider from '@mui/material/Divider';
// import SlecetorSubtitle from "./PopoverColorPicker/SlecetorSubtitle"
import ColorPicker from "./ColorPicker"
import { useContext, useEffect, useState } from "react";
import MainContext from "../../../context/mainContext";
import { customToastify } from "../../pages/utils/utilsFunctions"
import Button from '@mui/material/Button';
import HelpIcon from '@mui/icons-material/Help';
import IconButton from '@mui/material/IconButton';
import { Typography } from '@mui/material';
import { getWordLearningListByLangApi, getReadyWordLearningListByLangApi } from "../../../services/leitnerApi"
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";


function createData(name, hidden, fontSize, textColor, backGroundColor) {
  return { name, hidden, fontSize, textColor, backGroundColor };
}

export default function SubtitleStylesSettings({ handleOpenModalAlert, handlePlayingStatus }) {
  const { handleOpenSignInBox, subtitleStylesData, handleSubtitleStylesData, userTypes } = useContext(MainContext);

  const handleChangeValue = (value, type, key) => {
    if (userTypes.includes("userPremium") || userTypes.includes("admin") || userTypes.includes("freetrial_all")) return true
    else if (userTypes.includes("user")) {
      if (type == "fontSize" || type == "hidden") return true
      else {
        handleOpenModalAlert()
        return false
      }
    }
    else {
      if (type == "color" || type == "backGroundColor") {
        handleOpenSignInBox()
        handlePlayingStatus(false)
      } else {
        customToastify("error", "لطفا ابتدا لاگین کنید")
        handleOpenSignInBox()
        handlePlayingStatus(false)
      }
      return false
    }
  };

  const changeData = (subNumber, type, value) => {
    if (handleChangeValue(value, type)) {
      let copyValue = { ...subtitleStylesData };
      copyValue[`sub${subNumber}_${type}`] = value
      handleSubtitleStylesData(copyValue);
    }
  };


  const getColor = (subNumber, type) => {
    return subtitleStylesData[`sub${subNumber}_${type}`]
  }
  const colorSelector = (subNumber, type) => {
    return <Box sx={{ display: "flex", my: 1, p: 0 }} ><ColorPicker changeData={changeData} subNumber={subNumber} type={type} defaultColor={getColor(subNumber, type)} /></Box>
  }

  const fontSelector = (subNumber) => {
    return <select value={subNumber == "1" ? subtitleStylesData[`sub1_fontSize`] : subNumber == "2" ? subtitleStylesData[`sub2_fontSize`] : subtitleStylesData[`subdict_fontSize`]} style={{ width: "45px", padding: 0, margin: 0, textAlign: "center" }} onChange={(e) => { changeData(subNumber, "fontSize", e.target.value) }}>
      <option value={10} >10</option>
      <option value={15} >15</option>
      <option value={20} >20</option>
      <option value={25} >25</option>
      <option value={30} >30</option>
      <option value={35} >35</option>
      <option value={40} >40</option>
      <option value={45} >45</option>
      <option value={50} >50</option>
      <option value={55} >55</option>
      <option value={60} >60</option>
    </select>
  }

  const helpClick = () => {
    window.open("https://doc.umlang.com/", "mozillaWindow", "popup");
  }

  const rows = [
    createData('اول', <Paper sx={{ display: "inline-flex", alignItems: "center", m: 0, p: 0, width: "min-content" }} onClick={() => { changeData("1", "hidden", !subtitleStylesData[`sub1_hidden`]) }}>{subtitleStylesData[`sub1_hidden`] ? <VisibilityOffIcon color="error" /> : <VisibilityIcon color="success" />}</Paper>, fontSelector("1"), <Paper sx={{ display: "inline-flex", alignItems: "center", m: 0, p: 0, width: "min-content" }}>{colorSelector("1", "color")}</Paper>, <Paper sx={{ display: "inline-flex", alignItems: "center", m: 0, p: 0, width: "min-content" }}>{colorSelector("1", "backGroundColor")}</Paper>),
    createData('دوم', <Paper sx={{ display: "inline-flex", alignItems: "center", m: 0, p: 0, width: "min-content" }} onClick={() => { changeData("2", "hidden", !subtitleStylesData[`sub2_hidden`]) }}>{subtitleStylesData[`sub2_hidden`] ? <VisibilityOffIcon color="error" /> : <VisibilityIcon color="success" />}</Paper>, fontSelector("2"), <Paper sx={{ display: "inline-flex", alignItems: "center", m: 0, p: 0, width: "min-content" }}>{colorSelector("2", "color")}</Paper>, <Paper sx={{ display: "inline-flex", alignItems: "center", m: 0, p: 0, width: "min-content" }}>{colorSelector("2", "backGroundColor")}</Paper>),
    createData('دیشکنری', <Paper sx={{ display: "inline-flex", alignItems: "center", m: 0, p: 0, width: "min-content" }} ></Paper>, fontSelector("dict"), <Paper sx={{ display: "inline-flex", alignItems: "center", m: 0, p: 0, width: "min-content" }}>{colorSelector("dict", "color")}</Paper>, <Paper sx={{ display: "inline-flex", alignItems: "center", m: 0, p: 0, width: "min-content" }}></Paper>),
  ];



  return (
    <TableContainer component={Paper}>
      <Divider>تنظیمات نمایش زیرنویس</Divider>
      <Table size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>زیرنویس</TableCell>
            <TableCell sx={{ p: 0 }} align="left">نمایش/پنهان</TableCell>
            <TableCell sx={{ p: 0 }} align="left">اندازه</TableCell>
            <TableCell sx={{ p: 0 }} align="right">رنگ متن</TableCell>
            <TableCell sx={{ p: 0 }} align="right">رنگ پس زمینه</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.name}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell sx={{ p: 0 }} component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell sx={{ p: 0 }} align="center">{row.hidden}</TableCell>
              <TableCell sx={{ p: 0 }} align="center">{row.fontSize}</TableCell>
              <TableCell sx={{ p: 0 }} align="center">{row.textColor}</TableCell>
              <TableCell sx={{ p: 0 }} align="center">{row.backGroundColor}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Typography sx={{ fontSize: "smaller" }}>- راهنما :<IconButton onClick={helpClick} color="info"  ><HelpIcon />
      </IconButton></Typography>
      <Button
        onClick={() => {
          handleSubtitleStylesData({
            sub1_key: "1",
            sub1_subNumber: "اول",
            sub1_hidden: false,
            sub1_name: "1",
            sub1_fontSize: 35,
            sub1_color: "rgba(0, 255, 2, 1)",
            sub1_backGroundColor: "rgba(0, 0, 0, 0.75)",
            sub2_key: "2",
            sub2_subNumber: "دوم",
            sub2_hidden: false,
            sub2_name: "2",
            sub2_fontSize: 35,
            sub2_color: "rgba(246, 255, 0, 1)",
            sub2_backGroundColor: "rgba(0, 0, 0, 0.75)",
            subdict_fontSize: 20,
            subdict_color: "rgba(0, 0, 0, 1)",
          })
        }}
        variant="contained"
        color="error"
        size='small'
        sx={{ left: "31px", position: "absolute", my: 1, p: 0 }}
      >
        ریست تنظیمات زیرنویس
      </Button>
    </TableContainer>
  );
}